var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Konto")]),_c('br')]),_c('b-col',[_c('p',[_vm._v("Dieser Bereich ist in arbeit.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }